@if(document != null && !addItem && !isMessageAttachment)
{
<h2 mat-dialog-title>{{document.fileDesc}}</h2>
}
@if(addItem && !isMessageAttachment){
  <h2 mat-dialog-title>File Information</h2>
} 
@if(isMessageAttachment){
  <h2 mat-dialog-title>Attach</h2>
}
<mat-dialog-content>

  
  @if(shouldShowDocumentDetails()){
  <mat-card appearance="outlined" [ngClass]="getStatus()"  class="m-b-1">
    <mat-card-content class="text-align-center">
      @switch (getStatus()) {
      @case ("other") {
       <h3>Sent by you</h3>
       <div>The documents listed below were uploaded by you using the 'Add Item' button. Please limit the size of any upload to 5MB, with a combined total document upload limit
        of 28MB.</div>
      }
      @case ("complete") {
      <h3>Completed</h3>
      <div>Any documents you have uploaded for this item will appear below if available. Please note that uploaded documents may be removed after a certain period. Each upload is limited to 5MB, with a combined total upload limit of 28MB.</div>
      }
      @case ("rejected") {
      <h3>Upload Rejected</h3>

       <div [innerHTML]="document?.rejectionReason"></div>
      <div>
        @if (document?.instructions) {
        <div [innerHTML]="document!.instructions"></div>
        }
        @else {
        Upload the requested <b>{{document?.fileDesc}}</b>. Please ensure that each upload does not exceed 5MB in size,
        with a combined total document upload limit of 28MB.
        }
      </div>
      }
      @case ("incomplete") {
      <h3>Document Required</h3>
      <div>
        @if (document?.instructions) {
        <div [innerHTML]="document!.instructions"></div>
        }
        @else {
        Upload the requested <b>{{document?.fileDesc}}</b>. Please ensure that each upload does not exceed 5MB in size,
        with a combined total document upload limit of 28MB.
        }
      </div>
      }
      }
    </mat-card-content>
  </mat-card>
  }


  @if(addItem || (isMessageAttachment && !attachmentUploaded)){
  <div class="select-documents-container">
    <app-document-select [matterId]="matterId" [documentSelection]="documentSelection" [isMessageAttachment]="isMessageAttachment"
      (onSelectionChanged)="handleDocumentSelection($event)"></app-document-select>
  </div>
  }


  @if(document != null && !attachmentUploaded && (childDocuments.length == 0 || confirmedUploadExtraDocs)){
  <div class="d-flex justify-content-center">
    <div class="upload-documents-container">
      <app-document-upload [document]="document" [uploadType]="isMessageAttachment ? 'message' : ''" [matterId]="document.matterId" (onUpload)="handleOnUpload($event)"
        (onError)="handleOnError($event)" (onCancelled)="handleOnCancelled()"></app-document-upload>
    </div>
  </div>
  
}@else if(document != null && !attachmentUploaded && (childDocuments.length > 0 && !confirmedUploadExtraDocs)){
  <p align="center" class="">You have already uploaded a file for this request! Are you sure you want to proceed?</p>
  <mat-dialog-actions align="center">
  <button mat-flat-button type="button" (click)="confirmedUploadExtraDocs = true"><mat-icon fontSet="material-symbols-outlined">upload</mat-icon> Continue</button>
  <button mat-flat-button mat-dialog-close class="cancel-button" type="button" (click)="confirmedUploadExtraDocs = false"><mat-icon fontSet="material-symbols-outlined">close</mat-icon> Cancel</button>
  </mat-dialog-actions>
 
}


  @if(uploadResultMessage){

  <div  class="mat-elevation-z2" [ngClass]="{
              'alert-success': uploadResultMessageType === 'success',
              'alert-error': uploadResultMessageType === 'error',
              'fade-out': fadeOutAlert && uploadResultMessageType === 'success'
            }" style="margin: 16px 0; padding: 16px; border-radius: 4px; position: relative;">
    {{ uploadResultMessage }}
    <button mat-icon-button aria-label="Dismiss" (click)="uploadResultMessage = null"
      style="position: absolute; top: 8px; right: 8px;">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  }
  @if(childDocuments.length > 0){
     @if(!isSmallScreen){
  <div>
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">{{getTruncatedFileName(element.fileName)}}</td>
      </ng-container>

      <ng-container matColumnDef="hash">
        <th mat-header-cell *matHeaderCellDef>Hash</th>
        <td mat-cell *matCellDef="let element" class="overflow-wrap-anywhere"><app-hidden-copy-display
            [value]="element.hash" textDescription="Hash"></app-hidden-copy-display></td>
      </ng-container>

      <ng-container matColumnDef="uploaded">
        <th mat-header-cell *matHeaderCellDef>Uploaded</th>
        <td mat-cell *matCellDef="let element">{{element.timeUploaded | dateTimeFromIso | dateTimeToFormat: 'MMM dd,
          yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="size">
        <th mat-header-cell *matHeaderCellDef>Size</th>
        <td mat-cell *matCellDef="let element">{{element.fileSize | byteFormat}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  }

  @if(isSmallScreen){
  <div class="card-container">
    @for (element of dataSource.data; track $index) {
  <mat-card appearance="outlined">
     <mat-card-content class="card">
      <div><strong>Name:</strong></div><div>{{ getTruncatedFileName(element.fileName) }}</div>
      <div><strong>Uploaded:</strong></div><div>{{element.timeUploaded | dateTimeFromIso | dateTimeToFormat: 'MMM dd, yyyy HH:mm' }}</div>
      <div><strong>Hash:</strong></div><div><app-hidden-copy-display [value]="element.hash" textDescription="Hash"></app-hidden-copy-display></div>
      <div><strong>Size:</strong></div><div>{{ element.fileSize != null ? (element.fileSize | byteFormat) : '' }}</div>
    </mat-card-content>
  </mat-card>
}
</div>  }
}
</mat-dialog-content>
@if(childDocuments.length == 0 || confirmedUploadExtraDocs || attachmentUploaded){
  <mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
}